<template>
  <footer v-bem="{rtl: $i18n.locale === 'ar'}">
    <div class="row top">
      <div class="col-7">
        <div v-bem:newsletter>
          <p v-bem:title v-if="submitStatus !== 'SENT'">{{$t('newsletter.title')}}</p>
          <div v-bem:confirm v-if="submitStatus === 'SENT'">
            <div class="intro"><img src="@/assets/img/icons/confirm.svg" alt=""></div>
            <div class="content"><p>{{$t('newsletter.sent')}}</p></div>
          </div>
          <Loader v-if="submitStatus === 'PENDING'" />
          <form @submit.prevent="submit" ref="form" class="form" v-if="submitStatus !== 'SENT' && submitStatus !== 'PENDING'">
            <div class="row">
              <div class="col-8">
                <div class="form-control">
                  <input
                    v-model="$v.email.$model"
                    type="email"
                    name="email"
                    :class="{error: $v.email.$dirty && $v.email.$invalid}"
                    :placeholder="`${$t('form.email')} *`"
                  >
                  <div class="errors" v-if="$v.email.$dirty">
                    <p v-if="!$v.email.required">{{$t('form.error.required.email')}}</p>
                    <p v-if="!$v.email.custom_email">{{$t('form.error.valid.email')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <button type="submit" class="button button--secondary"><span class="button__text">{{$t('cta.send')}}</span></button>
              </div>
            </div>
          </form>
          <p v-if="submitStatus === 'SUBMIT_ERROR'" class="text-center">{{$t('form.error.send')}}</p>
        </div>
      </div>
      <div class="col-5">
        <p v-bem:title>{{$t('newsletter.social')}}</p>
        <ul v-bem:social>
          <li v-bem:social:item v-for="(social, index) in socials" :key="'social-'+index">
            <a v-bem:social:icon :href="social.link" :title="social.icon" target="_blank" rel="noopener"><Icon :name="social.icon" /></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row bottom">
      <div class="col-6">
        <a :href="`https://www.succursalesrenault.ma/pages/informations_legales`" target="_blank">{{$t('footer.legals')}}</a>
        <a :href="`https://www.succursalesrenault.ma/pages/cookies`" target="_blank">{{$t('footer.cookies')}}</a>
      </div>
      <div class="col-6 text-right">
        <p>{{$t('footer.copyright')}} {{currentYear}}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { validationMixin } from 'vuelidate'
import axios from 'axios'
import { helpers, required } from 'vuelidate/lib/validators'
const custom_email = helpers.regex('custom_email', /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)

export default {
  name: 'AppFooter',
  components: {
    Icon  : () => import('@/components/Icon.vue'),
    Loader: () => import('@/components/Loader.vue')
  },
  mixins: [validationMixin],
  data: () => ({
    submitStatus: '',
    email: '',
    socials: [
			{ icon: 'facebook', link: 'https://www.facebook.com/SuccursalesRenaultMaroc/' },
			{ icon: 'instagram', link: 'https://www.instagram.com/renaultmarocsuccursales/' },
			{ icon: 'youtube', link: 'https://www.youtube.com/channel/UCpEN0ifV-KDPXFkI_FNFN5g' }
		]
  }),
  validations: {
    email: {
      required,
      custom_email,
    },
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) this.submitStatus = 'ERROR'
      else {
        this.submitStatus  = 'PENDING'
        axios.post(`https://succursalesrenault.ma/onlinestore/admin/public/api/newsletter`, {
          email   : this.email,
          source  : this.$store.getters.utm.source,
          campaign: this.$store.getters.utm.campaign
        })
          .then(({status}) => {
            if (status === 200 || status === 201) {
              this.submitStatus = 'SENT'
              this.email = ''
              setTimeout(() => {
                this.submitStatus = ''
                this.$v.$reset()
              }, 7000)
            }
          })
          .catch(err => {
            this.submitStatus = 'SUBMIT_ERROR'
            console.error(err)
          })
      }
    }
  },
  computed: {
    currentYear() {
      const today = new Date()
      return today.getFullYear()
    }
  }
}
</script>

<style lang="scss">
.app-footer {
  background-color: rgba(var(--primary-color), 1);
  padding: rem(30) rem($gutter * 2);
  margin-top: rem(60);
  a {
    color: $white;
    &:not(:last-child) {
      padding-right: rem(20);
    }
  }
  p {
    font-family: var(--primary-font-bold);
    @include font-size(14);
    color: $white;
  }
  .bottom {
    padding-top: rem(16);
    margin-top: rem(16);
    border-top: rem(1) solid $white;
  }
  p.app-footer__title {
    font-family: var(--primary-font-bold);
    @include font-size(18);
    color: $white;
    margin-bottom: rem(24);
    // max-width: rem(380);
  }
  &__social {
    &-item {
      display: inline-block;
      &:not(:last-child) {
        margin-right: rem(16);
      }
    }
		&-icon {
			position: relative;
			width: rem(32);
			height: rem(32);
			border: rem(1) solid $white;
			background-color: rgba(var(--primary-color), 1);
			border-radius: 50%;
			@include transition(background, border);
			.icon {
				@extend %transform-center;
				width: rem(16) !important;
				height: rem(16) !important;
				fill: $white;
			}
			&:hover {
				background-color: $white;
				.icon {
          fill: rgba(var(--primary-color), 1);
				}
			}
		}
  }
  &__newsletter {
    max-width: rem(380);
    margin: 0;
    [class^="col"] {
      padding: 0;
    }
    .form {
      .errors p:first-child {
        margin-top: rem(4);
      }
      &-control {
        input[type="email"] {
          height: rem(44);
          border: rem(1) solid $white;
          color: $white;
          &:focus {
            border-color: $white;
          }
          &:-webkit-autofill,
          &:-webkit-autofill:hover,
          &:-webkit-autofill:focus {
            -webkit-text-fill-color: $white;
            box-shadow: 0 0 0px 1000px transparent inset;
            transition: background-color 5000s ease-in-out 0s;
            color: $white;
          }
          &::-webkit-input-placeholder {
            color: $white;
          }
          &::-moz-placeholder {
            color: $white;
          }
          &:-ms-input-placeholder {
            color: $white;
          }
          &:-moz-placeholder {
            color: $white;
          }
          &.error {
            color: $white;
            border-color: $white;
            &::-webkit-input-placeholder {
              color: $white;
            }
            &::-moz-placeholder {
              color: $white;
            }
            &:-ms-input-placeholder {
              color: $white;
            }
            &:-moz-placeholder {
              color: $white;
            }
          }
        }
      }
    }
    .button.button--secondary {
      border: 0;
      margin: 0;
    }
  }
  .loader {
    margin: 0 auto !important;
  }
  &__confirm {
    text-align: center;
    padding: rem(0) rem(8);
    margin-bottom: rem(24);
    .intro {
      margin-bottom: rem(8);
      img {
        max-width: rem(60);
      }
    }
    .content {
      p {
        strong {
          font-family: var(--primary-font-bold) !important;
        }
      }
    }
  }
  &--rtl {
    a {
      &:not(:last-child) {
        padding-right: 0;
        padding-left: rem(20);
      }
    }
    .row {
      &.top {
        text-align: left;
        .col-7 {
          float: left;
        }
      }
    }
    .app-footer {
      &__social {
        &-item {
          &:not(:last-child) {
            margin-right: unset;
            margin-left: rem(16);
          }
        }
      }
      &__newsletter {
        float: left;
        margin-left: rem(56);
        .app-footer__title {
          text-align: right;
        }
      }
    }
    @include breakpoint('charmander') {
      .app-footer {
        .row {
          &.top {
            text-align: center;
            .col-7 {
              float: unset;
            }
            .col-5 {
              text-align: center;
            }
          }
        }
        &__title {
          text-align: center;
        }
        &__social {
          text-align: center;
        }
        &__newsletter {
          float: unset;
          margin-left: auto;
          .app-footer__title {
            text-align: center;
          }
          .button {
            margin: 0 auto;
            display: table;
          }
        }
      }
    }
  }
  @include breakpoint('charmander') {
    text-align: center;
    margin-top: rem(30);
    .text-right {
      text-align: center;
    }
    a {
      @include font-size(14);
    }
    p {
      margin-top: rem(20);
      @include font-size(12);
    }
    &__newsletter {
      margin: 0 auto;
    }
    &__title {
      margin: 0 auto;
    }
  }
}
</style>
